import { financeAPI } from "../../axios";

export const actions = {
    GetRequestType(){
        return financeAPI.get(`RequestType/All`);
    },
    GetSingleRequestType(context, data){
        return financeAPI.get(`RequestType/${data}`);
    },
    UpdateRequestType(context, data){
        return financeAPI.put(`RequestType/${data.id}`, data);
    },
    DeleteRequestType(context, data){
        return financeAPI.delete(`RequestType/${data}`);
    },
    CreateRequestType(context, data){
        return financeAPI.post(`RequestType/Add`, data);
    },
}